/**
 * Use in viewport utility. It's a hook that uses the IntersectionObserver API to detect if an element is in the viewport or not.
 * Source: https://github.com/airfleet/airfleet-elements-core-plugin/blob/main/assets/frontend/scripts/utils/useInViewport.js
 * @param {string | Element | Element[]} selectorOrElements
 * @param {Function} intersecting
 * @param {Function} notIntersecting
 * @param {object} options
 * @returns {void}
 */

const createIntersectionObserver = (intersecting, notIntersecting, options) => {
  const { once, observerOptions } = options;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        intersecting(entry.target);

        if (once) {
          observer.unobserve(entry.target);
        }

        return
      }

      notIntersecting(entry.target);
    });
  }, observerOptions);

  return observer;
};

export default function (
  selectorOrElements,
  intersecting = () => null,
  notIntersecting = () => null,
  options = {}
) {
  let domElements = [];

  if (typeof selectorOrElements === 'string') {
    domElements = [...document.querySelectorAll(selectorOrElements)];
  }

  if (selectorOrElements instanceof Element) {
    domElements = [selectorOrElements];
  }

  if (
    Array.isArray(selectorOrElements) &&
    selectorOrElements.every((element) => element instanceof Element)
  ) {
    domElements = selectorOrElements;
  }

  if (
    !Array.isArray(selectorOrElements) &&
    selectorOrElements instanceof NodeList
  ) {
    domElements = Array.from(selectorOrElements);
  }

  if (domElements.length === 0) {
    return;
  }

  const observerOptions = {
    once: false,
    ...options,
  };

  const observer = createIntersectionObserver(
    intersecting,
    notIntersecting,
    observerOptions
  );

  domElements.forEach((element) => {
    observer.observe(element);
  });
}



// WEBPACK FOOTER //
// ./scripts/util/useInViewport.js